import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { customElement, property } from 'lit/decorators.js';
import { html, nothing } from 'lit';
import { styles, tag } from './list.styles';
import './item/item.component';

@customElement(tag)
export class ListComponent extends TmElement {
  static override styles = styles;

  @property({ type: String, reflect: true })
  direction?: 'row' | 'column';

  override render() {
    return html`<ul role="none" direction="${this.direction ?? nothing}">
      <slot></slot>
    </ul>`;
  }

  override connectedCallback() {
    super.connectedCallback();
    this.setAttribute('role', 'list');
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-list': ListComponent;
  }
}
